<template>
  <div quote-slide v-editable="blok">
    <div class="quote-content" v-if="blok.content" v-html="content"></div>
    <div class="quote-author">
      <div class="quote-author-image">
        <img loading="lazy" v-if="blok.avatar?.filename" :src="optimizeImage(blok.avatar.filename)" :alt="`Quote Author - ${blok.name}`" />
      </div>
      <div class="quote-author-details">
        <div class="quote-author-name" v-text="blok.author"></div>
        <div class="quote-author-citation">{{ blok.citation }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({ blok: Object });
const content = computed(() => useRichText(props?.blok?.content || {}));
</script>
